export enum TranslationKey {
    Elements_BasicInfoPanel_name = "Elements.BasicInfoPanel.name",
    Diagrams_DiagramEditor_TopMenu_IgnoreStyles = "Diagrams.DiagramEditor.TopMenu.IgnoreStyles",
    DIAGRAMS_DIAGRAMEDITOR_MENUITEM_SHOW_HIDDEN_CONNECTIONS = "diagrams.diagramEditor.topMenu.showHiddenConnections",
    DIAGRAMS_DIAGRAMEDITOR_MENUITEM_MOVE_TO_FRONT = "diagrams.diagramEditor.topMenu.moveToFront",
    DIAGRAMS_DIAGRAMEDITOR_MENUITEM_MOVE_TO_BACK = "diagrams.diagramEditor.topMenu.moveToBack",
}